/**
 * Map the readable version of the event to the event ID used by Fathom Analytics. The key here does not necessarily have to match what's on fathom.
 * The point of the function is to avoid writing these event codes all over the place and to provide a more readable reference.
 * @param key
 * @returns {null|(string|number)[]} An array of 2 values with the first being the event code, and the second being the event value
 */
export default function getFathomEventByKey(key) {
  switch (key) {
    case 'hero > Component Initialized':
      return ['6XNO8VU9', 0]
    case 'hero > Clicked Sign Up For Updates':
      return ['HRECZKED', 10]
    case 'hero > Lead Submitted':
      return ['HRECZKED', 100]

    case 'hero-old > Component Initialized':
      return ['QH6WUJRJ', 0]
    case 'hero-old > Clicked Follow This Community':
      return ['QH6WUJRJ', 10]

    case 'interested-in > Component Initialized':
      return ['DALKDOOY', 0]
    case 'interested-in > Lead Submitted':
      return ['JBNCLELE', 100]

    case 'interested-in-old > Component Initialized':
      return ['AA0S2VKT', 0]
    case 'interested-in-old > Form Submitted':
      return ['2ZFKS39B', 100]

    case 'lbl-link > Component Initialized':
      return ['Q2Y1AXWB', 0]
    case 'lbl-link > Form Submitted':
      return ['CAUTOQ6I', 100]

    case 'map > Component Initialized':
      return ['UFYW5KUB', 0]
    case 'map > Clicked Category':
      return ['G9BBEXQA', 10]
    case 'map > Clicked Property':
      return ['Z3UXFM7A', 10]
    case 'map > Visited Listing Detail':
      return ['DMAE5QN9', 15]

    case 'map-yelp > Component Initialized':
      return ['JS7KEMIC', 0]
    case 'map-yelp > Clicked Category > Activities':
      return ['9GPPMOVG', 10]
    case 'map-yelp > Clicked Category > Coffee shops':
      return ['40P4HY7J', 10]
    case 'map-yelp > Clicked Category > Dog Parks':
      return ['S47LYENY', 10]
    case 'map-yelp > Clicked Category > Fitness':
      return ['FL9SSO1H', 10]
    case 'map-yelp > Clicked Category > Grocery stores':
      return ['0YD5N9DD', 10]
    case 'map-yelp > Clicked Category > Medical':
      return ['UYR03HIJ', 10]
    case 'map-yelp > Clicked Category > Nightlife':
      return ['HKLMFEWF', 10]
    case 'map-yelp > Clicked Category > Parks':
      return ['NJE9OPRV', 10]
    case 'map-yelp > Clicked Category > Restaurants':
      return ['LNIJXHV9', 10]
    case 'map-yelp > Clicked Category > Shopping':
      return ['CXMWXPRQ', 10]
    case 'map-yelp > Clicked Amenity Card':
      return ['7UI9XICN', 10]
    case 'map-yelp > Clicked Property':
      return ['Z3UXFM7A', 10]
    case 'map-yelp > Visited Listing Detail':
      return ['R3OMIBCA', 15]

    case 'new-listings > Component Initialized':
      return ['EK7JQHSQ', 0]
    case 'new-listings > Form Submitted':
      return ['NNAYJXK2', 100]

    case 'properties > Component Initialized':
      return ['9HSHDIEG', 0]
    case 'properties > Visited Listing Detail':
      return ['OKVB8LO4', 15]

    case 'send-message-chat > Component Initialized':
      return ['82BL5NKA', 0]
    case 'send-message-chat > Clicked Chat Icon':
      return ['VLH4KTXW', 10]
    case 'send-message-chat > Clicked Email':
      return ['KUFB7HX6', 100]
    case 'send-message-chat > Clicked Phone Number':
      return ['KLYPMC0H', 100]
    case 'send-message-chat > Clicked Pill > Connect with an agent':
      return ['S5DLQ5RF', 10]
    case 'send-message-chat > Clicked Pill > Determine home value':
      return ['CKG22JCQ', 10]
    case 'send-message-chat > Clicked Pill > Get report monthly':
      return ['3LITQBXW', 10]
    case 'send-message-chat > Clicked Pill > Mortgage approval':
      return ['COC18XT1', 10]
    case 'send-message-chat > Clicked Pill > Nearby listings':
      return ['VFCRJF82', 10]
    case 'send-message-chat > Clicked Pill > New listing alerts':
      return ['FJ50DAQU', 10]
    case 'send-message-chat > Clicked Pill > Sell my property':
      return ['PREDZL2V', 10]
    case 'send-message-chat > Clicked Send Another Message':
      return ['BPUFGP4S', 10]
    case 'send-message-chat > Clicked Send Message':
      return ['NASXWBHK', 10]
    case 'send-message-chat > Lead Submitted':
      return ['ZFMUF06D', 100]

    case 'send-message-inline > Component Initialized':
      return ['OQYP9NGK', 0]
    case 'send-message-inline > Clicked Email':
      return ['HT5XSJT8', 100]
    case 'send-message-inline > Clicked Phone Number':
      return ['ZMNVWNQL', 100]
    case 'send-message-inline > Clicked Pill > Connect with an agent':
      return ['2XKL2XAS', 10]
    case 'send-message-inline > Clicked Pill > Determine home value':
      return ['IR3GE52Y', 10]
    case 'send-message-inline > Clicked Pill > Get report monthly':
      return ['AWNR8CC0', 10]
    case 'send-message-inline > Clicked Pill > Mortgage approval':
      return ['MDUUM3OA', 10]
    case 'send-message-inline > Clicked Pill > Nearby listings':
      return ['0OPMJN6E', 10]
    case 'send-message-inline > Clicked Pill > New listing alerts':
      return ['9XFEUE7X', 10]
    case 'send-message-inline > Clicked Pill > Sell my property':
      return ['DDD1W5OY', 10]
    case 'send-message-inline > Clicked Send Another Message':
      return ['OQXDYBJZ', 10]
    case 'send-message-inline > Clicked Send Message':
      return ['9HGZJUOM', 10]
    case 'send-message-inline > Lead Submitted':
      return ['LPZNMTOE', 100]

    case 'up-to-date > Component Initialized':
      return ['WWZSBIKC', 0]
    case 'up-to-date > Form Submitted':
      return ['SISONPRY', 100]
  }

  return null
}
